export default class GoogleAnalytics {
  constructor() {
    if (typeof window === 'undefined') {
      return;
    }

    if (__DEV__) {
      window.ga = (message, ...args) => {
        console.groupCollapsed(`[Google Analytics] ${message}`);
        console.debug(args);
        console.groupEnd();
      };
    }
  }

  trackPageview({ location }) {
    window.ga('send', 'pageview', location);
  }

  identifyUser({ id }) {
    window.ga('set', 'userId', id);
  }

  trackLogin({ backend }) {
    window.ga('send', 'event', 'Login', backend);
  }

  trackFailedLogin({ backend, reason }) {
    window.ga('send', 'event', 'Failed Login', backend, reason);
  }

  unidentifyUser() {
    window.ga('set', 'userId', null);
  }

  trackProductSearch({ query }) {
    window.ga('send', 'event', 'Search', 'Execute product Search', query);
  }

  trackProductCardClick({ listName }) {
    window.ga('send', 'event', 'Product Card', 'Click / Tap', listName);
  }

  trackLanguageChange({ language }) {
    window.ga('send', 'event', 'Language Picker', 'Select language', language);
  }

  trackOpenFeedback() {
    window.ga('send', 'event', 'User Feedback', 'Open');
  }

  trackOpenFollowers() {
    window.ga('send', 'event', 'User Followers', 'Open');
  }

  trackOpenFollowing() {
    window.ga('send', 'event', 'User Following', 'Open');
  }

  trackEditShop() {
    window.ga('send', 'event', 'Re-order Shop', 'Rearrange');
  }

  trackSaveEditShop() {
    window.ga('send', 'event', 'Re-order Shop', 'Save');
  }

  trackCancelEditShop() {
    window.ga('send', 'event', 'Re-order Shop', 'Cancel');
  }

  moveSoldItemsToBottom() {
    window.ga('send', 'event', 'Re-order Shop', 'Move sold to bottom');
  }

  trackCropperOpen() {
    window.ga('send', 'event', 'Cropper', 'Open');
  }

  trackCropperSave() {
    window.ga('send', 'event', 'Cropper', 'Save');
  }

  trackBeginListingFlow() {
    window.ga('send', 'event', 'Product Listing', 'Start');
  }

  trackConfirmListing() {
    window.ga('send', 'event', 'Product Listing', 'Publish');
  }

  trackConfirmListingAndAddAnother() {
    window.ga('send', 'event', 'Product Listing', 'Publish and add another');
  }

  trackDownLoadAppHeader({ source }) {
    window.ga('send', 'event', 'Download App', 'Click', source);
  }

  trackShowAB({ testId, variantId }) {
    window.ga('send', 'event', 'Web experiment started',
      `Web test ID: ${testId}`,
      `Web variant ID: ${variantId}`);
  }

  trackActionAB({ testId, variantId, button }) {
    window.ga('send', 'event', 'Web experiment variant action',
      `Web test ID: ${testId}`,
      `Web variant ID: ${variantId}`,
      `Web action button: ${button}`);
  }

  trackProfileGetTheApp({ username }) {
    window.ga('send', 'event', 'Profile download banner', 'Click',
      `Profile: ${username}`);
  }

  trackVideoPlay() {
    window.ga('send', 'event', 'product play video');
  }

}



// WEBPACK FOOTER //
// ../src/client/utils/tracking/GoogleAnalytics.js